import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  sortBy: "newest", // most recent first
  searchText: "",
  filterBy: "",
  filteredPanelsList: [],
};

export const panelSlice = createSlice({
  name: "panel",
  initialState,
  reducers: {
    setPanelSortBy: (state, action) => {
      state.sortBy = action.payload;
    },
    setPanelSearchText: (state, action) => {
      state.searchText = action.payload;
    },
    setPanelFilterBy: (state, action) => {
      state.filterBy = action.payload;
    },
    setFilteredPanelsList: (state, action) => {
      state.filteredPanelsList = action.payload;
    },
  },
});

export const {
  setPanelSortBy,
  setPanelSearchText,
  setPanelFilterBy,
  setFilteredPanelsList,
} = panelSlice.actions;

export default panelSlice.reducer;
